import http from '../http-common';
import authHeader from './auth-header';

let API_URL = '/api/auth/';

class AuthService {
  login(user, store) {
    return http
      .post(API_URL + 'signin', {
        username: user.username,
        password: user.password
      })
      .then(response => {
        if (response.data.accessToken) {
          localStorage.setItem('user', JSON.stringify(response.data));
          // localStorage.setItem('competition_id', response.data.competition_id || undefined);
          store.dispatch('competition/setSelectedCompetitionId', response.data.competition_id)
          // if (response.data.competition_id) {
          //   console.log("response.data.competition_id: "+ response.data.competition_id);
          //   // this.$store.dispatch('auth/setSelectedCompetition', response.data.competition_id)
          //   // this.$store.dispatch('auth/setSelectedCompetition', 111)
          //   //   .then(ret => {
          //   //     console.log("ret");
          //   //     console.log(ret);
          //   //     console.log("signin response - ret 2");
          //   //     return response.data;
          //   //   });
          // }
        }
        return response.data;
      });
  }

  logout() {
    localStorage.removeItem('user');
    localStorage.removeItem('competition_id');
    localStorage.removeItem('currentCompetition');
    localStorage.removeItem('selectedCompetition');
    window.location.href = '/';
  }

//  register(user) {
//    return axios.post(API_URL + 'signup', {
//      username: user.username,
//      email: user.email,
//      password: user.password
//    });
//  }


  register(user) {
    let localuser_unparsed = localStorage.getItem('user') || false;
    if ( !localuser_unparsed ) {
      return http.get('');
    }
    let localuser_parsed = JSON.parse(localuser_unparsed) || false;
    let accessToken = ''

    if (localuser_parsed && localuser_parsed.accessToken) {
      accessToken = localuser_parsed.accessToken;
    } else {
      return http.get('');
    }

    const options = {
      headers: {'x-access-token': accessToken}
    };

    return http.post(API_URL + 'signup',
        { username: user.username,
          email: user.email,
          password: user.password
        }, options);
    }

  getRoles() {
    return http
      .get(API_URL + `getRoles`, { headers: authHeader() })
      .then(response => {
        // console.log("getRoles - response");
        // console.log(response.data);
        return response.data;
      })
      .catch(error => {
        console.log("getRoles - error");
        console.log(error);
      });
  }
  
}

export default new AuthService();
